import {NOTIFICATION_TIMEOUT_HIDE_INFO_MESSAGE} from "@main/consts/delay";
import {getCookie, setCookie} from "@main/utils/cookie";

/**
 * Всплывающее уведомление.
 */
export class Notification {
    /**
     * Создает компонент.
     *
     * @param {HTMLElement} el Элемент-уведомление.
     */
    constructor(el) {
        this.el = el;
        this.type = this.el.dataset.type;
        this.cookieName = this.el.dataset.cookie;
        this.btnCookie = this.el.querySelector(".js-button-cookies");
        this.btnClose = this.el.querySelector(".js-notification-close");
        this.openBtn = document.querySelectorAll(".js-notification-button[data-type='" + this.type + "']");
        this.timer = null;
        this.bindEventListeners();
        this.autoShow();
        this.showByCookie();
    }

    /**
     * Показать плашку с уведомлением. Закртыть по таймауту, если нужно.
     *
     * @returns {void}
     */
    show() {
        this.el.classList.add("visible");

        if (this.el.classList.contains("js-auto-close")) {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.close();
                document.querySelector(".b24-widget-button-position-bottom-right.b24-widget-button-visible")?.classList.remove("b130");
                document.querySelector(".b24-widget-button-position-bottom-right.b24-widget-button-visible")?.classList.remove("b180");
                document.querySelector(".b24-widget-button-position-bottom-right.b24-widget-button-visible")?.classList.add("b50");
            }, NOTIFICATION_TIMEOUT_HIDE_INFO_MESSAGE);
        }
    }

    /**
     * Показать плашку с уведомлением автоматически при загрузке страницы
     *
     * @returns {void}
     */
    autoShow() {
        if(this.el.classList.contains("js-auto-notification")) {
            this.show();
        }
    }

    /**
     * Показать плашку с уведомлением в зависимости от куки.
     *
     * @returns {void}
     */
    showByCookie() {
        if (this.el.classList.contains("js-cookies-notification")) {
            if (getCookie(this.cookieName) !== "accept") {
                this.show();
            }
        }
    }

    /**
     * Закрыть плашку с уведомлением.
     *
     * @returns {void}
     */
    close() {
        this.el.classList.remove("visible");
    }

    /**
     * Обрабатываем клик. В случае если кликнули вне уведомления -
     * закрываем его. Если кликнули по кнопке - открываем
     *
     * @returns {void}
     */
    bindEventListeners() {
        if (this.btnCookie) {
            this.btnCookie.addEventListener("click", () => {
                setCookie(this.cookieName, "accept");
                this.close();
                document.querySelector(".b24-widget-button-position-bottom-right.b24-widget-button-visible")?.classList.remove("b130");
                document.querySelector(".b24-widget-button-position-bottom-right.b24-widget-button-visible")?.classList.remove("b180");
                document.querySelector(".b24-widget-button-position-bottom-right.b24-widget-button-visible")?.classList.add("b50");
            });
        }

        if (this.btnClose) {
            this.btnClose.addEventListener("click", () => {
                this.close();
                document.querySelector(".b24-widget-button-position-bottom-right.b24-widget-button-visible")?.classList.remove("b130");
                document.querySelector(".b24-widget-button-position-bottom-right.b24-widget-button-visible")?.classList.remove("b180");
                document.querySelector(".b24-widget-button-position-bottom-right.b24-widget-button-visible")?.classList.add("b50");
            });
        }

        if (this.openBtn.length) {
            this.openBtn.forEach((button) => {
                button.addEventListener("click", () => {
                    this.show();
                });
            });
        }

        document.addEventListener("click", (e) => {
            if (!e.target.classList.contains("js-notification-button")
                &&
                !e.target.classList.contains("js-notification")
                &&
                !e.target.closest(".js-notification")
                &&
                !this.el.classList.contains("js-cookies-notification")
            ) {
                this.close();
                document.querySelector(".b24-widget-button-position-bottom-right.b24-widget-button-visible")?.classList.remove("b130");
                document.querySelector(".b24-widget-button-position-bottom-right.b24-widget-button-visible")?.classList.remove("b180");
                document.querySelector(".b24-widget-button-position-bottom-right.b24-widget-button-visible")?.classList.add("b50");
            }
        });

        this.el.addEventListener("showNotification", () => {
            this.show();
        });
    }
}

window.addEventListener("load", () => {
    document.querySelectorAll(".js-notification").forEach(el => new Notification(el));
    buttonB24widget();
});

window.addEventListener("resize", function() {
    buttonB24widget();
}, true);

function buttonB24widget() {
    if (document.cookie.indexOf("accept") == "-1") {
        const width = document.documentElement.clientWidth;
        if (width <= 768 && width > 480) {
            document.querySelector(".b24-widget-button-position-bottom-right.b24-widget-button-visible")?.classList.remove("b50");
            document.querySelector(".b24-widget-button-position-bottom-right.b24-widget-button-visible")?.classList.remove("b180");
            document.querySelector(".b24-widget-button-position-bottom-right.b24-widget-button-visible")?.classList.add("b130");
        } else if (width <= 480) {
            document.querySelector(".b24-widget-button-position-bottom-right.b24-widget-button-visible")?.classList.remove("b50");
            document.querySelector(".b24-widget-button-position-bottom-right.b24-widget-button-visible")?.classList.remove("b130");
            document.querySelector(".b24-widget-button-position-bottom-right.b24-widget-button-visible")?.classList.add("b180");
        } else {
            document.querySelector(".b24-widget-button-position-bottom-right.b24-widget-button-visible")?.classList.remove("b130");
            document.querySelector(".b24-widget-button-position-bottom-right.b24-widget-button-visible")?.classList.remove("b180");
            document.querySelector(".b24-widget-button-position-bottom-right.b24-widget-button-visible")?.classList.add("b50");
        }
    }
}
